import { useQuery } from "@tanstack/react-query";
import http_payroll from "../../utils/http_payroll";
import { Api_EndPoints } from "../../utils/Api_EndPoints";

const getContributes = async () => {
  const data = await http_payroll.get(
    `${Api_EndPoints.CPFContributionAPI}?isAll=true`
  );
  return data;
};

export const useContributesQuery = () => {
  return useQuery({
    queryKey: [Api_EndPoints.CPFContributionAPI],
    queryFn: () => getContributes(),
     refetchOnWindowFocus: false,
    
  });
};
